<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
* {
  margin: 0;
  padding: 0;
  font-family: "Microsoft YaHei", "Helvetica";
  text-decoration: none;
  font-weight: normal;
  font-size: 1em;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  outline: none;
  word-wrap: break-word;
  font-weight: normal;
  list-style-type: none;
}
img {
  width: 100%;
  border: none;
  outline: none;
}

input {
  outline: none;
}
ul,
ol {
  list-style: none;
}
.layer {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4);
}
.layer-box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.layerLock{
  position: fixed;
  top: 0;
  bottom: 0%;
  left: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue